module.exports = __webpack_public_path__ + "img/es.083fe407.png";